import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FilterComplex, OperatorEnum } from 'src/app/shared/models/filtercomplex.model';
import { APISCockpit } from 'src/service/apis-cockpit';
import { ComponentesUtils } from 'src/utils/components-utils';
import { InputItem } from '../inputcommon/inputcommon.class';
import { InputTasks } from './inputtask';

const API = '/api/construction-projects/v1/cockpit-taskinputitens';
const APIInput = '/api/construction-projects/v1/inputs';

@Injectable({ providedIn: 'root' })
export class InputTasksService {

  private inputTasks = new InputTasks();
  private componentsUtils: ComponentesUtils;
  private page = 1;
  private pageSize = 4;

  constructor(private apiCockpit: APISCockpit) {}

  async GetInfoInputTask(itm: InputItem) {
    if (typeof(itm?.companyid) !== 'undefined') {
      this.inputTasks = await this.apiCockpit.getDataInfoPaginated(API, this.CreateParams(itm, this.page, this.pageSize, null));
      this.page++;
      return this.inputTasks;
    }
  }

  async GetInput(itm: InputItem) {
    if (typeof(itm?.companyid) !== 'undefined') {
      const input = await this.apiCockpit.getDataInfoPaginated(APIInput, this.CreateParams(itm, this.page, this.pageSize, null));
      this.page++;
      return input;
    }
  }

  async GetInfoTaskInputWithCostGroup(itm: InputItem, filters: Array<string>) {
    this.componentsUtils = new ComponentesUtils();
    if (typeof(itm?.companyid) !== 'undefined') {
      let filterComplexArray = new Array<FilterComplex>();
      filterComplexArray = this.CreateFilters(filterComplexArray, filters);
      this.inputTasks = await this.apiCockpit.getDataInfoPaginated(API, this.CreateParams(itm, this.page, this.pageSize,
                                                                                         this.componentsUtils.FiltersWithOperatorEnum(filterComplexArray)));
      this.page++;
      return this.inputTasks;
    }
  }

  private CreateFilters(FilterComplexArray: Array<FilterComplex>, filters: Array<string>) :FilterComplex[] {
    filters.forEach(filter => {
      let analyzedFilter = filter;
      if(filter.includes('.')){
        analyzedFilter = filter.split('.').join('');
      }
      const filterConvert = Number(analyzedFilter);
      if(filterConvert) {
        FilterComplexArray.push(new FilterComplex('taskCode', filter, OperatorEnum.StartWiths));
      }
      else {
        FilterComplexArray.push(new FilterComplex('taskName', filter, OperatorEnum.Contains));
        FilterComplexArray.push(new FilterComplex('taskDescription', filter, OperatorEnum.Contains));
      }
    });

    return FilterComplexArray;
  }

  private CreateParams(inputItem: InputItem, page: number, pageSize: number, filterComplex: string) :HttpParams {
    let params = new HttpParams();
    params = params.set('companyId', inputItem.companyid.toString());
    params = params.set('projectId', inputItem.projectid.toString());
    params = params.set('inputId', inputItem.inputId.toString());
    params = params.set('page', page.toString());
    params = params.set('pageSize', pageSize.toString());
    if(filterComplex != null && filterComplex && filterComplex?.length > 0) {
      params = params.set('$filter', filterComplex);
    }
    params = params.set('order','taskDescription');
    return params;
  }

  ResetPages() {
    this.page = 1;
  }
}
